// @flow
import isFunction from 'lodash/isFunction'
import * as React from 'react'

import cn from '@/utils/tailwind/cn'

import { ButtonGroup } from '../atoms/ButtonGroup'

type Props = {
  options: Array<{ id: string, title: React.ReactNode }>,
  onSelectOption: Function,
  initialSelectedIndex?: number,
  className?: string,
}

function Tabs({
  options,
  onSelectOption,
  initialSelectedIndex = 0,
  className,
}: Props): React.Node {
  const [selectedOption, setSelectedOption] = React.useState(
    initialSelectedIndex || 0
  )

  function selectOption(option: { id: string, title: string }, i: number) {
    if (i === selectedOption) return
    setSelectedOption(i)
    isFunction(onSelectOption) && onSelectOption(option)
  }

  return (
    <ButtonGroup.Root
      className={cn(
        'mb-3 w-[fit-content] gap-2 !border-blue-100 bg-[#e2edf8]',
        className
      )}
    >
      {options.map((item, i) => {
        const isActive = i === selectedOption
        return (
          <ButtonGroup.Item
            className={cn(
              'h-8 px-2.5 text-gray-800/80 hover:text-gray-800/50',
              isActive && '!cursor-default text-gray-900 hover:text-gray-900'
            )}
            isActive={isActive}
            key={item.id || item.title}
            onClick={() => selectOption(item, i)}
          >
            {item.title}
          </ButtonGroup.Item>
        )
      })}
    </ButtonGroup.Root>
  )
}

export default Tabs
